import { useMutation, useQueryClient } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import templateApi from '../services/templateApi';
import { extractMessageFromError } from '../utils/backEndErrorMessages';
import { AxiosError } from 'axios';

export const useChangeTemplateOwner = (templateUUID: string) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation(
    (userId: number) => {
      return templateApi.changeTemplateOwner(companyId, templateUUID, userId);
    },
    {
      onSuccess: async () => {
        showToast({
          title: t('common.toast.success'),
          description: t('template.changeOwner.success'),
          status: 'success',
          'data-cy': 'toast-change-owner-success',
        });

        await queryClient.invalidateQueries(['template']);
      },
      onError: (error: AxiosError) => {
        const errorMessage = extractMessageFromError(error);
        showToast({
          title: t('common.toast.error'),
          description: errorMessage,
          status: 'error',
          'data-cy': 'toast-change-owner-error',
        });
      },
    },
  );
};
